function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_191_10885)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.6806 7.27991L17.3106 2.7699C17.148 2.55898 16.9394 2.38797 16.7006 2.2699C16.4577 2.15145 16.1909 2.08984 15.9206 2.08984H7.38062L9.38062 4.08984H15.8606L18.9506 8.21985L16.2406 10.8999L17.6206 12.2699L20.5506 9.38989C20.8247 9.12446 20.995 8.7698 21.0306 8.38989C21.0626 7.98848 20.937 7.59039 20.6806 7.27991ZM13.8206 13.1998L10.8206 16.1998L2.98059 8.19983L5.45062 4.87988L4.06061 3.49988L1.22058 7.29993C1.00326 7.59586 0.898069 7.95929 0.923708 8.32556C0.949347 8.69183 1.10416 9.03715 1.3606 9.29993L9.57062 17.6499C9.73075 17.8165 9.92527 17.9462 10.1406 18.0299C10.3561 18.1189 10.5875 18.1631 10.8206 18.1599C11.2786 18.1618 11.7194 17.9862 12.0506 17.6699L15.2206 14.5499L13.8206 13.1998Z",
  fill: "#1565c0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2209 18.97C18.1037 18.9724 17.9872 18.9506 17.8788 18.9059C17.7704 18.8611 17.6724 18.7944 17.591 18.71L0.260986 1.52002C0.178254 1.43729 0.112646 1.33905 0.0678711 1.23096C0.0230964 1.12286 2.22419e-08 1.00702 0 0.890015C-2.22419e-08 0.773013 0.0230964 0.657168 0.0678711 0.549072C0.112646 0.440977 0.178254 0.342743 0.260986 0.26001C0.343719 0.177277 0.441953 0.111669 0.550049 0.0668945C0.658144 0.0221199 0.773989 -0.000976585 0.890991 -0.000976562C1.00799 -0.00097654 1.12384 0.0221198 1.23193 0.0668945C1.34003 0.111669 1.43826 0.177277 1.521 0.26001L18.851 17.4399C18.9743 17.5657 19.058 17.725 19.0917 17.8979C19.1254 18.0709 19.1076 18.2498 19.0405 18.4127C18.9734 18.5756 18.86 18.7153 18.7144 18.8143C18.5687 18.9134 18.3971 18.9675 18.2209 18.97Z",
  fill: "#1565c0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_191_10885"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 18.98,
  fill: "white"
})));

function SvgLose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLose);
export default __webpack_public_path__ + "static/media/Lose.3585fd79.svg";
export { ForwardRef as ReactComponent };